import request from '@/utils/request'

export default {
  getJoywokConfigParams: (params) => {
    return request.get('/joywok/config/', { params })
  },
  getEmployeeInfo: (code, params) => {
    return request.get(`/starbucks/sso/auto-login/${code}/`, { params })
  },
  checkAutoLogin: (params) => {
    return request.get('/starbucks/sso/', { params })
  }
}
